export default __webpack_public_path__ + "static/media/p2.c1c49224.jpeg";